import {BaseBlock, theme} from "../../../framework/js/core";
import {ContactForm7} from "../../../plugins/ContactForm7/ContactForm7";

export class ContactForm extends ContactForm7 {
  constructor(root) {
    super(root);
    
    let spin = $(`<i class="material-icons">rotate_right</i>`);
    this.spinner = $(document.createElement("div"));
    this.spinner.addClass("contact-form__spinner").append(spin);
    
    this.message = $(document.createElement("div"));
    this.message.addClass("contact-form__message");
    
    this.form.append(this.message);
    this.form.append(this.spinner);
    
    this.disablePopup();
    
    this.listenFor("successfulRequest", mutation => {
      this.message.html(`Tack för ditt meddelande <i class="material-icons">thumb_up</i>`).addClass("successful");
    });
  }
  
  showSpinner() {
    this.message.html("");
    this.spinner.addClass("spinner-active");
  }
  hideSpinner() {
    this.spinner.removeClass("spinner-active");
  }
}